import React, {useCallback, useContext, useEffect, useState} from 'react';
import Grid from "@mui/material/Grid";
import {useFormContext} from "react-hook-form";
import {AccordionActions, AccordionDetails, Button, Tooltip} from "@mui/material";
import {setOpenSnackbar} from "../../../../../services/AppServices";
import {setIntervista} from "../../../../../services/IntervistaServices";
import {IntervistaContext} from "../IntervistaOld";
import {AppContext} from "../../../../../App";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {
	bigNoteRegisterNotRequired,
} from "../../../../../utils/RegisterUtils";
import CustomMultiText from "../../../../widgets/inputs/CustomMultiText";
import {tipiInfoLavoro} from "../../../../../utils/arrays/Generics";
import {InfoLavorativeGrid} from "../content/InfoLavorativeGrid";

const InfoLavorativeStep = ({setStep}) => {
	const classes = BaseStyle();
	const {errors, register, getValues, trigger, setValue} = useFormContext();
	const intervistaContext = useContext(IntervistaContext);
	const appContext = useContext(AppContext);
	const [value1, setValue1] = useState(null);
	const [inputValue1, setInputValue1] = useState("");
	
	const goForward = useCallback(async () => {
		let result;
		let result1 = true;
		let result2 = true;
		let result3 = true;
		let data = getValues();
		result = await trigger([
			("tipoLavoro"),
			("appartieneComunita"),
		])
		if (data["tipoLavoro"] === tipiInfoLavoro[0] ||
			data["tipoLavoro"] === tipiInfoLavoro[1] ||
			data["tipoLavoro"] === tipiInfoLavoro[2]) {
			result1 = await trigger([
				("azienda"),
				("ultimoGiornoLavoro"),
				("dettaglioScuola"),
			])
		}
		if (data["tipoLavoro"] === tipiInfoLavoro[3]) {
			result1 = await trigger([
				("professione"),
				("ultimoGiornoLavoro"),
				("azienda"),
				("seguitoDaMedico"),
				("noteMedicoCompetente"),
			])
		}
		if (data["tipoLavoro"] === tipiInfoLavoro[4]) {
			result1 = await trigger([
				("professione"),
				("ultimoGiornoLavoro"),
				("azienda"),
				("seguitoDaMedico"),
			])
		}
		if (data["tipoLavoro"] === tipiInfoLavoro[7]) {
			result1 = await trigger([
				("azienda"),
				("professione"),
				("ultimoGiornoLavoro"),
				("azienda"),
				("rspp"),
				("cellulareRSPP"),
				("emailRSPP"),
			])
		}
		if (result && result1 && result2 && result3) {
			setIntervista(data, intervistaContext.dispatch);
			setStep(prevState => ++prevState);
		} else {
			setOpenSnackbar("error", "Controlla bene i dati inseriti!", appContext.dispatch);
		}
	}, [intervistaContext.dispatch, appContext.dispatch, setStep, getValues, trigger])
	
	useEffect(() => {
		register("indirizzoAzienda");
	}, [register])
	
	useEffect(() => {
		if (value1 !== null) {
			setValue("indirizzoAzienda", inputValue1)
			setValue("indirizzoAzienda", value1.place_id)
		}
	}, [value1, inputValue1, setValue])
	
	return (
		<React.Fragment>
			<AccordionDetails>
				<Grid container spacing={3}>
					
					<InfoLavorativeGrid value={value1} inputValue={inputValue1} setValue={setValue1}
					                    setInputValue={setInputValue1}/>
					
					<Grid item xs={12}>
						<CustomMultiText
							inputRef={register(bigNoteRegisterNotRequired)}
							name={"note1"}
							label={"Note aggiuntive"}
							autoFocus={false}
							error={errors["note1"]}
						/>
					</Grid>
				</Grid>
			</AccordionDetails>
			{setStep && <AccordionActions>
				<Tooltip title={"Torna al passo precedente"}>
					<Button size={"small"} variant={"text"}
					        style={{borderRadius: 24}}
					        className={classes.roundButton} onClick={() => setStep(1)}>
						<b>Torna indietro</b>
					</Button>
				</Tooltip>
				<Tooltip title={"Prosegui con il passo successivo"}>
					<Button size={"small"} color={"primary"} variant={"contained"}
					        disableElevation
					        style={{borderRadius: 24}}
					        className={classes.roundButton}
					        onClick={goForward}>
						<b>Prosegui</b>
					</Button>
				</Tooltip>
			</AccordionActions>}
		</React.Fragment>
	);
};

export default React.memo(InfoLavorativeStep);
